export const MASTER_PENDING  = '0';
export const MASTER_APPROVED = '1';

/** Column names differ per table (HBD_ for banks, HBB_ for branches). */
const APPROVAL_KEYS = [
  'HBD_IS_APPROVED', 'HBB_IS_APPROVED', 'IS_APPROVED', 'isApproved', 'p_isApproved',
];

const hasValue = (v) =>
  v !== undefined && v !== null && String(v).trim() !== '' && String(v) !== 'null';


export function isMasterApproved(row) {
  if (!row) return false;
  for (const key of APPROVAL_KEYS) {
    const v = row[key];
    if (hasValue(v)) {
      if (v === true) return true;
      if (v === false) return false;
      const s = String(v).trim().toLowerCase();
      return s === '1' || s === 'true' || s === 'yes';
    }
  }
  return false;
}

export const isMasterPending = (row) => !isMasterApproved(row);

export function countMasterPending(rows = []) {
  return rows.reduce((n, r) => n + (r && r.isApproved ? 0 : 1), 0);
}

const pad2 = (n) => String(n).padStart(2, '0');

/** 'YYYY-MM-DD HH:mm:ss' local time — what the API expects. */
export function masterApprovalTimestamp(d = new Date()) {
  return `${d.getFullYear()}-${pad2(d.getMonth() + 1)}-${pad2(d.getDate())} ` +
         `${pad2(d.getHours())}:${pad2(d.getMinutes())}:${pad2(d.getSeconds())}`;
}


export function masterApprovalParams(approved, approvedBy) {
  if (!approved) return { p_isApproved: MASTER_PENDING };
  return {
    p_isApproved: MASTER_APPROVED,
    p_hedApprovedBy: approvedBy,
    p_hedApprovedDate: masterApprovalTimestamp(),
  };
}


export const NEW_MASTER_IS_APPROVED = MASTER_PENDING;